"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1595],{

/***/ 43532:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ AcadamyAdvantages; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/components/Icon/index.tsx + 2 modules
var Icon = __webpack_require__(83896);
// EXTERNAL MODULE: ./src/components/Icon/IconTemplate.tsx + 1 modules
var IconTemplate = __webpack_require__(67139);
// EXTERNAL MODULE: ./src/hooks/useTranslation.tsx + 1 modules
var useTranslation = __webpack_require__(85683);
// EXTERNAL MODULE: ./src/ui/SectionTitle/Title.tsx + 1 modules
var Title = __webpack_require__(83297);
// EXTERNAL MODULE: ./src/ui/Content/Content.tsx + 1 modules
var Content = __webpack_require__(74920);
// EXTERNAL MODULE: ./node_modules/polished/dist/polished.esm.js + 8 modules
var polished_esm = __webpack_require__(96502);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 7 modules
var styled_components_browser_esm = __webpack_require__(50661);
// EXTERNAL MODULE: ./src/styles/theme.ts
var theme = __webpack_require__(49642);
;// CONCATENATED MODULE: ./src/components/AcademyAdvantages/AcademyAdvantages.elements.tsx



var Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "AcademyAdvantageselements__Wrapper",
  componentId: "sc-1kj7kqt-0"
})(["margin:", " 0 ", " 0;padding:", " 0;@media (min-width:", "px){display:flex;flex-direction:row;justify-content:space-between;}@media (min-width:", "px){padding:0;}"], (0,polished_esm/* rem */.hO)(15), (0,polished_esm/* rem */.hO)(45), (0,polished_esm/* rem */.hO)(30), theme/* breakpoints.sm */.A.sm, theme/* breakpoints.md */.A.md);
var Sections = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "AcademyAdvantageselements__Sections",
  componentId: "sc-1kj7kqt-1"
})(["font-size:", ";display:flex;flex-direction:column;@media (min-width:", "px){width:45%;}"], function (_ref) {
  var theme = _ref.theme;
  return theme.fontSizes.h6;
}, theme/* breakpoints.sm */.A.sm);
var Section = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "AcademyAdvantageselements__Section",
  componentId: "sc-1kj7kqt-2"
})(["margin-bottom:", ";"], (0,polished_esm/* rem */.hO)(40));
var SectionHeader = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "AcademyAdvantageselements__SectionHeader",
  componentId: "sc-1kj7kqt-3"
})(["display:flex;flex-direction:row;align-items:center;font-weight:", ";font-family:", ";svg{margin-right:", ";width:", ";height:", ";path{fill:", ";}}"], function (_ref2) {
  var theme = _ref2.theme;
  return theme.fontWeights.textBold;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.fonts.fontSecondary;
}, (0,polished_esm/* rem */.hO)(14), (0,polished_esm/* rem */.hO)(20), (0,polished_esm/* rem */.hO)(20), function (_ref4) {
  var theme = _ref4.theme;
  return theme.colors.primary;
});
var SectionDescription = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "AcademyAdvantageselements__SectionDescription",
  componentId: "sc-1kj7kqt-4"
})(["padding-top:", ";margin-left:", ";color:", ";line-height:", ";"], (0,polished_esm/* rem */.hO)(15), (0,polished_esm/* rem */.hO)(30), function (_ref5) {
  var theme = _ref5.theme;
  return theme.colors.grey;
}, (0,polished_esm/* rem */.hO)(30));
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/AcademyAdvantages/AcadamyAdvantages.tsx










var AcademyAdvantagesTemplate = function AcademyAdvantagesTemplate() {
  var _useTranslation = (0,useTranslation/* default */.Z)(),
      t = _useTranslation.t;

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(Content/* default */.Z, {
    withPadding: true,
    mobileSidePadding: 20,
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Title/* default */.C, {
      tagType: Title/* TitleTagTypes.H2 */.Z.H2,
      isBlack: true,
      children: t('academy.title')
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Wrapper, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(Sections, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(Section, {
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(SectionHeader, {
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(IconTemplate/* IconTemplate */._, {
              name: Icon/* Icons.CheckThin */.PJ.CheckThin
            }), t('academy.advantages.section1.label')]
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(SectionDescription, {
            dangerouslySetInnerHTML: {
              __html: t('academy.advantages.section1.description')
            }
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Section, {
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(SectionHeader, {
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(IconTemplate/* IconTemplate */._, {
              name: Icon/* Icons.CheckThin */.PJ.CheckThin
            }), t('academy.advantages.section3.label')]
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(SectionDescription, {
            dangerouslySetInnerHTML: {
              __html: t('academy.advantages.section3.description')
            }
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Section, {
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(SectionHeader, {
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(IconTemplate/* IconTemplate */._, {
              name: Icon/* Icons.CheckThin */.PJ.CheckThin
            }), t('academy.advantages.section5.label')]
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(SectionDescription, {
            dangerouslySetInnerHTML: {
              __html: t('academy.advantages.section5.description')
            }
          })]
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Sections, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(Section, {
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(SectionHeader, {
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(IconTemplate/* IconTemplate */._, {
              name: Icon/* Icons.CheckThin */.PJ.CheckThin
            }), t('academy.advantages.section4.label')]
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(SectionDescription, {
            dangerouslySetInnerHTML: {
              __html: t('academy.advantages.section4.description')
            }
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Section, {
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(SectionHeader, {
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(IconTemplate/* IconTemplate */._, {
              name: Icon/* Icons.CheckThin */.PJ.CheckThin
            }), t('academy.advantages.section2.label')]
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(SectionDescription, {
            dangerouslySetInnerHTML: {
              __html: t('academy.advantages.section2.description')
            }
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Section, {
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(SectionHeader, {
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(IconTemplate/* IconTemplate */._, {
              name: Icon/* Icons.CheckThin */.PJ.CheckThin
            }), t('academy.advantages.section6.label')]
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(SectionDescription, {
            dangerouslySetInnerHTML: {
              __html: t('academy.advantages.section6.description')
            }
          })]
        })]
      })]
    })]
  });
};

/* harmony default export */ var AcadamyAdvantages = (AcademyAdvantagesTemplate);

/***/ }),

/***/ 82935:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ AcademyProduct; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./src/hooks/useTranslation.tsx + 1 modules
var useTranslation = __webpack_require__(85683);
// EXTERNAL MODULE: ./src/ui/Button/Button.tsx + 1 modules
var Button = __webpack_require__(83537);
// EXTERNAL MODULE: ./src/ui/Lecturer/Lecturer.tsx + 1 modules
var Lecturer = __webpack_require__(58596);
// EXTERNAL MODULE: ./src/utils/person.utils.ts
var person_utils = __webpack_require__(19033);
// EXTERNAL MODULE: ./src/utils/url.utils.ts
var url_utils = __webpack_require__(8333);
// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__(30381);
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);
// EXTERNAL MODULE: ./src/constants/index.ts
var constants = __webpack_require__(40238);
// EXTERNAL MODULE: ./node_modules/polished/dist/polished.esm.js + 8 modules
var polished_esm = __webpack_require__(96502);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 7 modules
var styled_components_browser_esm = __webpack_require__(50661);
// EXTERNAL MODULE: ./src/styles/theme.ts
var theme = __webpack_require__(49642);
;// CONCATENATED MODULE: ./src/components/AcademyProduct2/AcademyProduct.elements.tsx



var Item = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "AcademyProductelements__Item",
  componentId: "sc-1bxm75k-0"
})(["margin-bottom:", ";width:100%;@media (min-width:", "px){display:flex;min-height:", ";}"], (0,polished_esm/* rem */.hO)(20), theme/* breakpoints.md */.A.md, (0,polished_esm/* rem */.hO)(185));
var Calendar = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "AcademyProductelements__Calendar",
  componentId: "sc-1bxm75k-1"
})(["background:", ";display:flex;flex-direction:column;padding:", " ", ";position:relative;@media (min-width:", "px){width:", ";}"], function (prop) {
  return prop.isConference ? prop.theme.colors.primaryMedium : prop.theme.colors.primaryLight;
}, (0,polished_esm/* rem */.hO)(15), (0,polished_esm/* rem */.hO)(10), theme/* breakpoints.md */.A.md, (0,polished_esm/* rem */.hO)(195));
var Topic = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "AcademyProductelements__Topic",
  componentId: "sc-1bxm75k-2"
})(["border:1px solid ", ";padding:", ";border-radius:", ";position:relative;width:100%;@media (min-width:", "px){padding:", ";}@media (min-width:", "px){display:flex;flex-direction:column;}"], function (_ref) {
  var theme = _ref.theme;
  return theme.colors.border;
}, (0,polished_esm/* rem */.hO)(20), (0,polished_esm/* rem */.hO)(16), theme/* breakpoints.sm */.A.sm, (0,polished_esm/* rem */.hO)(30), theme/* breakpoints.md */.A.md);
var TopicFirstRow = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "AcademyProductelements__TopicFirstRow",
  componentId: "sc-1bxm75k-3"
})(["display:flex;flex-direction:row;justify-content:space-between;padding-bottom:", ";font-weight:", ";.label{color:", ";font-size:", ";padding:", " ", ";font-weight:400;margin-left:", ";text-transform:uppercase;border-radius:", ";}.conferenceLabel{background:", ";}.courseLabel{background:", ";}"], (0,polished_esm/* rem */.hO)(15), function (_ref2) {
  var theme = _ref2.theme;
  return theme.fontWeights.textBold;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.colors.white;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.fontSizes.textSmall;
}, (0,polished_esm/* rem */.hO)(4), (0,polished_esm/* rem */.hO)(12), (0,polished_esm/* rem */.hO)(10), (0,polished_esm/* rem */.hO)(16), function (_ref5) {
  var theme = _ref5.theme;
  return theme.colors.black;
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.colors.dark;
});
var TopicSecondRow = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "AcademyProductelements__TopicSecondRow",
  componentId: "sc-1bxm75k-4"
})(["padding-bottom:", ";"], (0,polished_esm/* rem */.hO)(25));
var TopicThirdRow = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "AcademyProductelements__TopicThirdRow",
  componentId: "sc-1bxm75k-5"
})(["@media (min-width:", "px){display:flex;flex-direction:row;justify-content:space-between;align-items:flex-end;}"], theme/* breakpoints.sm */.A.sm);
var TopicTitle = styled_components_browser_esm/* default.h3.withConfig */.ZP.h3.withConfig({
  displayName: "AcademyProductelements__TopicTitle",
  componentId: "sc-1bxm75k-6"
})(["font-size:", ";line-height:", ";font-weight:", ";font-family:", ";background:none;padding:0;border:none;cursor:pointer;text-align:left;text-decoration:none;display:inline-block;@media (min-width:", "px){width:70%;font-size:", ";line-height:", ";}"], function (_ref7) {
  var theme = _ref7.theme;
  return theme.fontSizes.h6;
}, (0,polished_esm/* rem */.hO)(24), function (_ref8) {
  var theme = _ref8.theme;
  return theme.fontWeights.textBold;
}, function (_ref9) {
  var theme = _ref9.theme;
  return theme.fonts.fontSecondary;
}, theme/* breakpoints.sm */.A.sm, function (_ref10) {
  var theme = _ref10.theme;
  return theme.fontSizes.h5;
}, (0,polished_esm/* rem */.hO)(30));
var TopicDescription = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
  displayName: "AcademyProductelements__TopicDescription",
  componentId: "sc-1bxm75k-7"
})(["line-clamp:3;display:-webkit-box;-webkit-box-orient:vertical;-webkit-line-clamp:3;overflow:hidden;margin:0;line-height:1.75rem;color:", ";strong{color:rgb(46,46,46) !important;}"], function (_ref11) {
  var theme = _ref11.theme;
  return theme.colors.secondaryGrey;
});
var Lecturers = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "AcademyProductelements__Lecturers",
  componentId: "sc-1bxm75k-8"
})(["display:flex;flex-wrap:wrap;max-width:80%;"]);
var Tags = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "AcademyProductelements__Tags",
  componentId: "sc-1bxm75k-9"
})(["padding:", " 0;@media (min-width:", "px){padding:0;}"], (0,polished_esm/* rem */.hO)(15), theme/* breakpoints.md */.A.md);
var TopicPlaces = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "AcademyProductelements__TopicPlaces",
  componentId: "sc-1bxm75k-10"
})(["padding:", " 0;display:flex;"], (0,polished_esm/* rem */.hO)(15));
var TopicPlace = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "AcademyProductelements__TopicPlace",
  componentId: "sc-1bxm75k-11"
})(["color:", ";"], function (_ref12) {
  var theme = _ref12.theme;
  return theme.colors.secondaryGrey;
});
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/AcademyProduct2/AcademyProduct.tsx














var AcademyProductTemplate = function AcademyProductTemplate(_ref) {
  var _event$academy2, _eventDetail$venues, _eventDetail$venues2, _eventDetail$people;

  var event = _ref.event;

  var _useTranslations = (0,useTranslation/* default */.Z)(),
      t = _useTranslations.t;

  var router = (0,next_router.useRouter)();

  var _useState = (0,react.useState)({}),
      eventDetail = _useState[0],
      setEventDetail = _useState[1];

  var _useState2 = (0,react.useState)(''),
      myDate = _useState2[0],
      setDate = _useState2[1];

  (0,react.useEffect)(function () {
    var _result$date_from, _result$date_to;

    var peopleMap = new Map();
    var venuesMap = new Map();
    var dateFromSet = new Set();
    var dateToSet = new Set();
    var isOnline = false;
    event.modules.forEach(function (item) {
      if (item.date_from) {
        dateFromSet.add(item.date_from);
      }

      if (item.date_to) {
        dateToSet.add(item.date_to);
      }

      item.events.forEach(function (event) {
        event.eventDates.forEach(function (ed) {
          var _ed$venues;

          if (!((_ed$venues = ed.venues) !== null && _ed$venues !== void 0 && _ed$venues.length)) {
            isOnline = true;
          }

          ed.people.forEach(function (person) {
            peopleMap.set(person._id, person);
          });
          ed.venues.forEach(function (venue) {
            venuesMap.set(venue._id, venue);
          });
        });
      });
    });
    var result = {
      people: Array.from(peopleMap.values()),
      venues: Array.from(venuesMap.values()),
      date_from: Array.from(dateFromSet),
      date_to: Array.from(dateToSet),
      isOnline: isOnline
    };
    setEventDetail(result);
    var min = result === null || result === void 0 ? void 0 : (_result$date_from = result.date_from) === null || _result$date_from === void 0 ? void 0 : _result$date_from.reduce(function (a, b) {
      return a < b ? a : b;
    });
    var max = result === null || result === void 0 ? void 0 : (_result$date_to = result.date_to) === null || _result$date_to === void 0 ? void 0 : _result$date_to.reduce(function (a, b) {
      return a > b ? a : b;
    });
    var myDate;

    if (moment_default()(min).format('D. M. YYYY') === moment_default()(max).format('D. M. YYYY')) {
      myDate = moment_default()(min).format('D. M. YYYY');
      setDate(myDate);
    } else {
      myDate = "".concat(moment_default()(min).format('D. M. YYYY'), " - ").concat(moment_default()(max).format('D. M. YYYY'));
      setDate(myDate);
    }
  }, [event]);

  var buildRedirectPathname = function buildRedirectPathname() {
    var _event$academy;

    return "".concat(constants/* ROUTES.ACADEMY_DETAIL */.Z6.ACADEMY_DETAIL, "/").concat((_event$academy = event.academy) === null || _event$academy === void 0 ? void 0 : _event$academy.slug);
  };

  return /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(Item, {
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Topic, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(TopicFirstRow, {
          children: myDate
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)(TopicSecondRow, {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(TopicTitle, {
            onClick: function onClick() {
              return router.push(buildRedirectPathname());
            },
            children: event === null || event === void 0 ? void 0 : (_event$academy2 = event.academy) === null || _event$academy2 === void 0 ? void 0 : _event$academy2.title
          }), (eventDetail === null || eventDetail === void 0 ? void 0 : (_eventDetail$venues = eventDetail.venues) === null || _eventDetail$venues === void 0 ? void 0 : _eventDetail$venues.length) > 0 && /*#__PURE__*/(0,jsx_runtime.jsx)(TopicPlaces, {
            children: eventDetail === null || eventDetail === void 0 ? void 0 : (_eventDetail$venues2 = eventDetail.venues) === null || _eventDetail$venues2 === void 0 ? void 0 : _eventDetail$venues2.map(function (item) {
              return /*#__PURE__*/(0,jsx_runtime.jsx)(TopicPlace, {
                children: item.name
              }, item);
            })
          }), (eventDetail === null || eventDetail === void 0 ? void 0 : eventDetail.isOnline) && /*#__PURE__*/(0,jsx_runtime.jsx)(TopicPlaces, {
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(TopicPlace, {
              children: "online"
            })
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
          children: /*#__PURE__*/(0,jsx_runtime.jsxs)(TopicThirdRow, {
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Lecturers, {
              children: (_eventDetail$people = eventDetail.people) === null || _eventDetail$people === void 0 ? void 0 : _eventDetail$people.map(function (person, key) {
                return /*#__PURE__*/(0,jsx_runtime.jsx)(Lecturer/* default */.Z, {
                  image: person !== null && person !== void 0 && person.photo ? "".concat((0,constants/* getImageBaseURL */.P9)(), "/media/people/").concat(person === null || person === void 0 ? void 0 : person.photo) : "".concat((0,url_utils/* publicAssets */.VK)('/avatar.svg')),
                  name: (0,person_utils/* formatLecturerName */.v)(person),
                  slug: person === null || person === void 0 ? void 0 : person.slug
                }, "lecturer-".concat(key));
              })
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(Button/* default */.Z, {
              marginTop: 10,
              onClick: function onClick() {
                return router.push({
                  pathname: buildRedirectPathname()
                });
              },
              text: t('homepage.calendar.button.detail')
            })]
          })
        })]
      })
    })
  });
};

/* harmony default export */ var AcademyProduct = (AcademyProductTemplate);

/***/ }),

/***/ 29135:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Hero; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/components/Icon/index.tsx + 2 modules
var Icon = __webpack_require__(83896);
// EXTERNAL MODULE: ./src/components/Icon/IconTemplate.tsx + 1 modules
var IconTemplate = __webpack_require__(67139);
// EXTERNAL MODULE: ./src/hooks/useTranslation.tsx + 1 modules
var useTranslation = __webpack_require__(85683);
// EXTERNAL MODULE: ./src/utils/url.utils.ts
var url_utils = __webpack_require__(8333);
// EXTERNAL MODULE: ./node_modules/polished/dist/polished.esm.js + 8 modules
var polished_esm = __webpack_require__(96502);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 7 modules
var styled_components_browser_esm = __webpack_require__(50661);
// EXTERNAL MODULE: ./src/constants/index.ts
var constants = __webpack_require__(40238);
// EXTERNAL MODULE: ./src/styles/theme.ts
var theme = __webpack_require__(49642);
;// CONCATENATED MODULE: ./src/ui/Hero/Hero.elements.tsx




var Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Heroelements__Wrapper",
  componentId: "sc-1nsgps3-0"
})(["display:flex;padding:", " ", ";max-width:", ";margin:", " auto ", " auto;min-height:", ";flex-direction:column-reverse;@media (min-width:", "px){margin:", " auto ", " auto;}@media (min-width:", "px){flex-direction:row;align-items:center;padding:0;}"], (0,polished_esm/* rem */.hO)(40), (0,polished_esm/* rem */.hO)(20), (0,polished_esm/* rem */.hO)(1180), (0,polished_esm/* rem */.hO)(constants/* MOBILE_HEADER_HEIGHT */.ZQ), (0,polished_esm/* rem */.hO)(40), (0,polished_esm/* rem */.hO)(500), theme/* breakpoints.sm */.A.sm, (0,polished_esm/* rem */.hO)(constants/* DESKTOP_HEADER_HEIGHT */.cf), (0,polished_esm/* rem */.hO)(40), theme/* breakpoints.md */.A.md);
var Image = styled_components_browser_esm/* default.img.withConfig */.ZP.img.withConfig({
  displayName: "Heroelements__Image",
  componentId: "sc-1nsgps3-1"
})(["width:100%;border-radius:", ";height:auto;margin-top:", ";@media (min-width:", "px){display:block;margin-top:", ";width:", ";}"], (0,polished_esm/* rem */.hO)(10), (0,polished_esm/* rem */.hO)(30), theme/* breakpoints.md */.A.md, (0,polished_esm/* rem */.hO)(0), (0,polished_esm/* rem */.hO)(600));
var About = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Heroelements__About",
  componentId: "sc-1nsgps3-2"
})(["@media (min-width:", "px){padding-left:", ";}"], theme/* breakpoints.md */.A.md, (0,polished_esm/* rem */.hO)(65));
var Title = styled_components_browser_esm/* default.h1.withConfig */.ZP.h1.withConfig({
  displayName: "Heroelements__Title",
  componentId: "sc-1nsgps3-3"
})(["font-weight:", ";font-size:", ";font-family:", ";padding-bottom:", ";@media (min-width:", "px){font-size:", ";}"], function (_ref) {
  var theme = _ref.theme;
  return theme.fontWeights.textBold;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.fontSizes.h3;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.fonts.fontSecondary;
}, function (props) {
  return props.withoutBottomPadding ? 0 : (0,polished_esm/* rem */.hO)(30);
}, theme/* breakpoints.md */.A.md, function (_ref4) {
  var theme = _ref4.theme;
  return theme.fontSizes.h2;
});
var Description = styled_components_browser_esm/* default.h3.withConfig */.ZP.h3.withConfig({
  displayName: "Heroelements__Description",
  componentId: "sc-1nsgps3-4"
})(["font-size:", ";font-weight:", ";padding:", " 0 ", " 0;line-height:", ";color:", ";"], function (_ref5) {
  var theme = _ref5.theme;
  return theme.fontSizes.h6;
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.fontWeights.textRegular;
}, (0,polished_esm/* rem */.hO)(30), (0,polished_esm/* rem */.hO)(30), (0,polished_esm/* rem */.hO)(30), function (_ref7) {
  var theme = _ref7.theme;
  return theme.colors.grey;
});
var Label = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "Heroelements__Label",
  componentId: "sc-1nsgps3-5"
})(["font-size:", ";line-height:", ";display:flex;margin-bottom:", ";svg{width:", ";height:", ";margin-right:", ";margin-top:", ";polyline{stroke:black;}}"], function (_ref8) {
  var theme = _ref8.theme;
  return theme.fontSizes.h6;
}, (0,polished_esm/* rem */.hO)(26), (0,polished_esm/* rem */.hO)(14), (0,polished_esm/* rem */.hO)(22), (0,polished_esm/* rem */.hO)(22), (0,polished_esm/* rem */.hO)(8), (0,polished_esm/* rem */.hO)(2));
var Benefit = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Heroelements__Benefit",
  componentId: "sc-1nsgps3-6"
})(["display:flex;flex-direction:column;align-items:center;flex-wrap:wrap;width:50%;margin-bottom:", ";@media (min-width:", "px){width:25%;margin-bottom:0;}@media (min-width:", "px){flex-direction:row;}"], (0,polished_esm/* rem */.hO)(40), theme/* breakpoints.sm */.A.sm, theme/* breakpoints.lg */.A.lg);
var Benefits = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Heroelements__Benefits",
  componentId: "sc-1nsgps3-7"
})(["display:flex;justify-content:space-between;padding:0 0 ", " 0;flex-wrap:wrap;margin-top:", ";max-width:", ";margin:", " auto ", " auto;"], (0,polished_esm/* rem */.hO)(20), (0,polished_esm/* rem */.hO)(10), (0,polished_esm/* rem */.hO)(1180), (0,polished_esm/* rem */.hO)(-40), (0,polished_esm/* rem */.hO)(40));
var BenefitNumber = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "Heroelements__BenefitNumber",
  componentId: "sc-1nsgps3-8"
})(["font-size:", ";font-family:", ";font-weight:700;color:", ";padding-right:", ";white-space:nowrap;"], (0,polished_esm/* rem */.hO)(48), function (_ref9) {
  var theme = _ref9.theme;
  return theme.fonts.fontSecondary;
}, function (_ref10) {
  var theme = _ref10.theme;
  return theme.colors.primary;
}, (0,polished_esm/* rem */.hO)(15));
var BenefitLabel = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "Heroelements__BenefitLabel",
  componentId: "sc-1nsgps3-9"
})(["font-weight:", ";font-size:", ";text-align:center;line-height:", ";@media (min-width:", "px){text-align:left;}"], function (_ref11) {
  var theme = _ref11.theme;
  return theme.fontWeights.textBold;
}, function (_ref12) {
  var theme = _ref12.theme;
  return theme.fontSizes.textBase;
}, (0,polished_esm/* rem */.hO)(20), theme/* breakpoints.sm */.A.sm);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/ui/Hero/Hero.tsx










var HeroTemplate = function HeroTemplate(_ref) {
  var titleKey = _ref.titleKey,
      imageKey = _ref.imageKey,
      listKeys = _ref.listKeys,
      descriptionKey = _ref.descriptionKey,
      withBenefits = _ref.withBenefits;

  var _useTranslations = (0,useTranslation/* default */.Z)(),
      t = _useTranslations.t;

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(Wrapper, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Image, {
        src: (0,url_utils/* publicAssets */.VK)("/".concat(imageKey))
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(About, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Title, {
          dangerouslySetInnerHTML: {
            __html: t(titleKey)
          },
          withoutBottomPadding: (listKeys === null || listKeys === void 0 ? void 0 : listKeys.length) > 0 && !!descriptionKey
        }), descriptionKey && /*#__PURE__*/(0,jsx_runtime.jsx)(Description, {
          dangerouslySetInnerHTML: {
            __html: t(descriptionKey)
          }
        }), (listKeys === null || listKeys === void 0 ? void 0 : listKeys.length) > 0 && (listKeys === null || listKeys === void 0 ? void 0 : listKeys.map(function (listKey, key) {
          return /*#__PURE__*/(0,jsx_runtime.jsxs)(Label, {
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(IconTemplate/* IconTemplate */._, {
              name: Icon/* Icons.CheckThin */.PJ.CheckThin
            }), ' ', /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
              dangerouslySetInnerHTML: {
                __html: t(listKey)
              }
            })]
          }, key);
        }))]
      })]
    }), withBenefits && /*#__PURE__*/(0,jsx_runtime.jsxs)(Benefits, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(Benefit, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(BenefitNumber, {
          children: t('homepage.benefit1.number')
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(BenefitLabel, {
          dangerouslySetInnerHTML: {
            __html: t('homepage.benefit1.label')
          }
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Benefit, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(BenefitNumber, {
          children: t('homepage.benefit2.number')
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(BenefitLabel, {
          dangerouslySetInnerHTML: {
            __html: t('homepage.benefit2.label')
          }
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Benefit, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(BenefitNumber, {
          children: t('homepage.benefit3.number')
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(BenefitLabel, {
          dangerouslySetInnerHTML: {
            __html: t('homepage.benefit3.label')
          }
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Benefit, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(BenefitNumber, {
          children: t('homepage.benefit4.number')
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(BenefitLabel, {
          dangerouslySetInnerHTML: {
            __html: t('homepage.benefit4.label')
          }
        })]
      })]
    })]
  });
};

/* harmony default export */ var Hero = (HeroTemplate);

/***/ }),

/***/ 83297:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ TitleTagTypes; },
  "C": function() { return /* binding */ Title; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/polished/dist/polished.esm.js + 8 modules
var polished_esm = __webpack_require__(96502);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 7 modules
var styled_components_browser_esm = __webpack_require__(50661);
// EXTERNAL MODULE: ./src/styles/theme.ts
var theme = __webpack_require__(49642);
;// CONCATENATED MODULE: ./src/ui/SectionTitle/Title.element.tsx



var TitleStyles = (0,styled_components_browser_esm/* css */.iv)(["font-size:", ";line-height:", ";font-weight:", ";font-family:", ";padding:", ";", ";", ";@media (min-width:", "px){font-size:", ";line-height:", ";", ";padding:", ";}"], function (_ref) {
  var theme = _ref.theme;
  return theme.fontSizes.h4;
}, (0,polished_esm/* rem */.hO)(40), function (_ref2) {
  var theme = _ref2.theme;
  return theme.fontWeights.textBold;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.fonts.fontSecondary;
}, function (prop) {
  return prop.$withoutPadding ? 0 : "".concat((0,polished_esm/* rem */.hO)(20), " 0");
}, function (prop) {
  return prop.$isBlack ? "color: ".concat(prop.theme.colors.black, ";") : "color: ".concat(prop.theme.colors.primary, ";");
}, function (prop) {
  return prop.$alignCenter ? 'text-align: center;' : '';
}, theme/* breakpoints.sm */.A.sm, function (_ref4) {
  var theme = _ref4.theme;
  return theme.fontSizes.h3;
}, (0,polished_esm/* rem */.hO)(44), function (prop) {
  return prop.$alignLeft ? 'text-align: left;' : 'text-align: center;';
}, function (prop) {
  return prop.$withoutPadding ? 0 : "".concat((0,polished_esm/* rem */.hO)(15), " 0 ").concat((0,polished_esm/* rem */.hO)(60), " 0");
});
var WrapperDiv = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Titleelement__WrapperDiv",
  componentId: "sc-s8z71i-0"
})(["", ""], TitleStyles);
var WrapperH1 = styled_components_browser_esm/* default.h1.withConfig */.ZP.h1.withConfig({
  displayName: "Titleelement__WrapperH1",
  componentId: "sc-s8z71i-1"
})(["", ""], TitleStyles);
var WrapperH2 = styled_components_browser_esm/* default.h2.withConfig */.ZP.h2.withConfig({
  displayName: "Titleelement__WrapperH2",
  componentId: "sc-s8z71i-2"
})(["", ""], TitleStyles);
var WrapperH3 = styled_components_browser_esm/* default.h3.withConfig */.ZP.h3.withConfig({
  displayName: "Titleelement__WrapperH3",
  componentId: "sc-s8z71i-3"
})(["", ""], TitleStyles);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/ui/SectionTitle/Title.tsx



var TitleTagTypes;

(function (TitleTagTypes) {
  TitleTagTypes["H1"] = "h1";
  TitleTagTypes["H2"] = "h2";
  TitleTagTypes["H3"] = "h3";
})(TitleTagTypes || (TitleTagTypes = {}));

var TitleTemplate = function TitleTemplate(_ref) {
  var children = _ref.children,
      alignLeft = _ref.alignLeft,
      alignCenter = _ref.alignCenter,
      withoutPadding = _ref.withoutPadding,
      isBlack = _ref.isBlack,
      tagType = _ref.tagType;

  if (tagType === TitleTagTypes.H1) {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(WrapperH1, {
      $withoutPadding: withoutPadding,
      $alignLeft: alignLeft,
      $alignCenter: alignCenter,
      $isBlack: isBlack,
      children: children
    });
  }

  if (tagType === TitleTagTypes.H3) {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(WrapperH3, {
      $withoutPadding: withoutPadding,
      $alignLeft: alignLeft,
      $alignCenter: alignCenter,
      $isBlack: isBlack,
      children: children
    });
  }

  if (tagType === TitleTagTypes.H2) {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(WrapperH2, {
      $withoutPadding: withoutPadding,
      $alignLeft: alignLeft,
      $alignCenter: alignCenter,
      $isBlack: isBlack,
      children: children
    });
  }

  return /*#__PURE__*/(0,jsx_runtime.jsx)(WrapperDiv, {
    $withoutPadding: withoutPadding,
    $alignLeft: alignLeft,
    $alignCenter: alignCenter,
    $isBlack: isBlack,
    children: children
  });
};

/* harmony default export */ var Title = (TitleTemplate);

/***/ })

}]);